import { CurrencyNumberPipe } from "../../pipes/currency-number.pipe";

export class CashSaleModel {
	public id: any;
	public item: any;
	public status: string;
	public quantity: number;
	public discountId: string;
	public tax: number;
	public price: number;
	public rePrice: number = 0;
	public reTax: number = 0;
  public discountValue: number = 0;
	public invoiceNum: string;
}

export class InvoiceModel {
	public patientref: string;
	public fullname: string;
	public dateOfbirth: string;
	public invoiceno: string;
	public invoicedate: any;
	public invoiceto: any;
	public orderno: any
}

export class PayMethodModel {
	constructor(
		public totalDue: string = '0.00',
		public totalEntered: string = '0.00',
		public due: string = '0.00',
	) {
		this.totalDue = totalDue;
		this.totalEntered = totalEntered;
		this.due = due;
	}
}

// export class SelectedProductModel {
// 	public searchproduct: any;
// 	public productcategory: any;
// 	public product: any;
// 	public quantity: any;

// }
export class ProductModel {
	constructor(
		public id: string = '',
		public name: string = '',
		public productCategoryId: string = '',
		public supplierId: string = '',
		public description: string = '',
		public quantity: number = 0,
	) {
		this.id = id;
		this.name = name;
		this.productCategoryId = productCategoryId;
		this.supplierId = supplierId;
		this.description = description;
		this.quantity = quantity;
	}
}

export class ProductCategoryModel {
	constructor(
		public id: string = '',
		public name: string = ''
	) {
		this.id = id;
		this.name = name;
	}
}

export class PayMethodObjModel {
	constructor(
		public id = null,
		public name = null,
		public value = null
	) {
		this.id = id;
		this.name = name;
		this.value = value;
	}
}

export class InvoicePayMethodModel {
	constructor(public adjustment = '0.00',
		public payMethod = new Array<PayMethodObjModel>(),
		public paymentAmount = 0) {
		this.adjustment = adjustment;
		this.payMethod = payMethod;
		this.paymentAmount = paymentAmount;
	}
}

export class ProductCashSale {
	constructor(
		public id: string = '',
		public product?: ProductModel,
		public category?: ProductCategoryModel,
		public quantity?: number
	) {
		this.id = id;
		this.product = product ? product : null;
		this.category = category ? category : null;
		this.quantity = quantity || null;
	}
}

export class CreditNoteModel {
	public note: any;
	public amount: any

}

export class NoteInvoiceModel {
	public note: any;

}

export enum PartyType {
	Individual = 0,
	Group = 1,
	FluVaccine = 2,
	Blocked = 3
}

export enum InvoiceItemStatus {
	Administered = 1,
	NotAdminsterd = 2,
	Ordered = 3,
	CreditNote = 4,
	Paid = 5
}

export enum InvoiceItemType {
	Vaccine = 1,
	Prescription = 2,
	LabTest = 3,
	Product = 4,
	Adjustment = 5,
	Refund = 6,
	CreditNote = 7,
}

export class CurrencyModel {
	constructor(
		public id: string = '1',
		public code: string = 'EUR',
		public symbol: string = 'Ç',
		public name: string = 'Euro',
		public symbolPosition: string = 'L'
	) {
		this.id = id;
		this.code = code;
		this.symbol = symbol;
		this.name = name;
		this.symbolPosition = symbolPosition;
	}
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/consultation/cash-sale.model.ts